import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VSConsensusGridComponent } from "./vsconsensus-grid/vsconsensus-grid.component";
import { VSConsensusPageComponent } from "./vsconsensus-page/vsconsensus-page.component";
import { RouterModule, Routes } from "@angular/router";
import { IconsModule } from "@va/core-library/icons";
import { FormsModule } from "@angular/forms";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { SharedModule } from "../shared/shared.module";
import { RightPanelModule } from "../right-panel/right-panel.module";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzTableModule } from "ng-zorro-antd/table";

const vsconsensusRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: VSConsensusPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(vsconsensusRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class VSConsensusRoutingModule {}

@NgModule({
  declarations: [VSConsensusGridComponent, VSConsensusPageComponent],
  imports: [
    CommonModule,
    VSConsensusRoutingModule,
    IconsModule,
    SharedModule,
    FormsModule,
    ChartPlotterModule,
    RightPanelModule,
    NzLayoutModule,
    NzSelectModule,
    NzSwitchModule,
    NzInputModule,
    NzToolTipModule,
    NzPopoverModule,
    NzTableModule,
  ],
})
export class VSConsensusPageModule {}
